module.exports = __webpack_public_path__ + "img/buiran.18615842.svg";